import type { KeyValue } from 'ngrx-forms';

import type { NGRXProgressiveFormsActions } from '../actions';
import { BackupFormStateAction } from '../actions';
import type { ProgressiveFormGroupState } from '../state';

export function backupFormStateReducer<TValue extends KeyValue>(
  state: ProgressiveFormGroupState<TValue>,
  action: NGRXProgressiveFormsActions
): ProgressiveFormGroupState<TValue> {
  if (action.type !== BackupFormStateAction.TYPE) {
    return state;
  }

  if (action.stepId !== state.id) {
    return state;
  }

  return {
    ...state,
    backupFormState: state.formState,
  };
}
